module.exports = __webpack_public_path__ + "img/transport_paavirkning_utslipp.bdf1c9e5.jpg";